import { h as __h } from "preact";
/** @import { ComponentChildren } from "preact"; */
import { signal } from "@preact/signals";
import { Component, toChildArray } from "preact";
import html from "~/util/html.js";
import adminStyle from "~/admin/lib/style.js";

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {ComponentChildren} [children]
 * @property {number} [max] Chips shown while collapsed
 */
export default class ChipList extends Component {
  #expanded = signal(false);
  #expand = () => {
    this.#expanded.value = true;
  };
  render() {
    const {
      children,
      max = 2
    } = this.props;
    const chips = toChildArray(children);
    if (chips.length <= max || this.#expanded.value) return chips;
    const text = `+${chips.length - max} more`;
    return [chips.slice(0, max), __h("button", {
      type: "button",
      "class": adminStyle.chip,
      onClick: this.#expand
    }, text)];
  }
}